<template>
  <div id="personal">
    <div class="header">
      <div class="user" @click="jumpRouter(personInfo.isLogin?'UserInfo':'Login')">
        <div class="avatar">
          <van-image class="img" :src="userInfo.avatar || require('@/assets/images/avatar_default_05.png')" fit="cover" round></van-image>
        </div>
        <div class="content">
          <div class="name text-ellipsis">{{ personInfo.isLogin?userInfo.name || '未设置昵称，点击前往设置！' : '立即登录'}}</div>
        </div>
        <button v-if="personInfo.isLogin" type="button" class="btn">编辑资料</button>
      </div>
    </div>
    <div class="container">
      <div class="list">
        <div class="list-item" @click="jumpRouter('Activity',{params:{type: 'myActivityDetail'}})">
          <div class="left">
            <i class="icon icon-1"></i>
            <div class="name">我的活动</div>
          </div>
          <i class="icon icon-arrow"></i>
        </div>
        <div class="list-item" @click="jumpRouter('Order')">
          <div class="left">
            <i class="icon icon-2"></i>
            <div class="name">我的订单</div>
          </div>
          <i class="icon icon-arrow"></i>
        </div>
        <div class="list-item" @click="jumpRouter('Collect')">
          <div class="left">
            <i class="icon icon-4"></i>
            <div class="name">我的收藏</div>
          </div>
          <i class="icon icon-arrow"></i>
        </div>
        <div class="list-item" @click="jumpRouter('StudyRecord')">
          <div class="left">
            <i class="icon icon-5"></i>
            <div class="name">学习记录</div>
          </div>
          <i class="icon icon-arrow"></i>
        </div>
        <div class="list-item" @click="jumpRouter('Exchange')">
          <div class="left">
            <i class="icon icon-6"></i>
            <div class="name">我的兑换</div>
          </div>
          <i class="icon icon-arrow"></i>
        </div>
        <div class="list-item" @click="jumpRouter('More')">
          <div class="left">
            <i class="icon icon-7"></i>
            <div class="name">更多</div>
          </div>
          <i class="icon icon-arrow"></i>
        </div>
      </div>
      <button class="logout" type="button" v-if="personInfo.isLogin" @click="logOut">退出登录</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Personal',
  computed: {
    // 获取用户信息
    ...mapGetters(['personInfo']),
    userInfo () {
      const { personInfo: { user } } = this;
      return user || {};
    }
  },
  components: {},
  data () {
    return {};
  },
  created () {
  },
  mounted () {

  },
  watch: {},
  methods: {

    /* 退出登录 */
    logOut () {
      const { $utils, $dialog } = this;
      $dialog.confirm({
        title: '提示',
        message: '是否退出登录'
      }).then(() => {
        this.$http.post('security/logout', {
          showLoading: true,
          loadingText: '退出中...'
        }).then((res) => {
          $utils.successToast({
            message: '退出成功！',
            onClose: () => {
              this.$utils.storage.remove('loginToken');
              // 为了SSO对接测试，暂时写死广哥的手机号，用于演示统一登录效果
              if (['13501529850','15918799136', '18529415358', '13711493228', '13632485326'].find(v => v == this.personInfo.user.mobile)) {
                this.$http.get('security/ssoLogoutUrl').then(res => {
                  let redirectUrl = window.location.href
                  window.location.href = res.data.ssoLogoutUrl + '?redirect_url=' + encodeURIComponent(redirectUrl)
                })
              }else{
                location.reload();
              }
            }
          });
        });
      });
    },
    jumpRouter (name, other) {
      this.$router.push({ name, ...other });
    }
  }
};
</script>

<style scoped lang="less">
#personal{
  height: 100%;
  display: flex;
  flex-direction: column;
  .header {
    height: 302px;
    background: url('~@/assets/images/bg_blue_01.png') no-repeat center top/cover;
    padding: 108px 28px 74px;
    .user {
      display: flex;
      align-items: center;
      .avatar {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background-color: #98E6FF;
        margin-right: 20px;
        .img {
          width: 100%;
          height: 100%;
        }
      }
      .content {
        flex:1;
        width: 0;
        .name {
          font-weight: bold;
          font-size: 28px;
          color: #fff;
        }
      }
      .btn {
        height: 50px;
        font-size: 22px;
        color: #FFFFFF;
        background-color: #7A94FF;
        border-radius: 100px;
        padding-left: 20px;
        padding-right: 20px;
        margin-left: 20px;
      }
    }
  }
  .container {
    flex: 1;
    height: 0;
    margin-top: -74px;
    background-color: #fff;
    box-shadow: 0 -6px 12px rgba(0, 0, 0, 0.01);
    border-radius: 20px 20px 0 0;
    position: relative;
    padding-bottom: 40px;
    overflow-y: auto;
    .list {
      .list-item {
        min-height: 100px;
        padding: 20px 28px;
        &, .left {
          display: flex;
          align-items: center;
        }
        .left {
          flex: 1;
          .icon {
            width: 36px;
            height: 36px;
            margin-right: 24px;
            .loop-icon(1, 'icon_personal', 8)
          }
          .name {
            flex: 1;
            width: 0;
            font-size: 26px;
          }
        }

        .icon-arrow {
          width: 28px;
          height: 28px;
          background-image: url("~@/assets/images/icon_arrow_03.png");
          margin-left: 24px;
        }
      }
    }
    .logout {
      width: 398px;
      height: 72px;
      font-size: 24px;
      display: block;
      color: #999AAA;
      border: 2px solid #999AAA;
      background-color: #fff;
      border-radius: 40px;
      margin: 124px auto 0;
    }
  }
}
</style>